import { Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent { }



// WEBPACK FOOTER //
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/app.component.ts